import { inject, observer } from 'mobx-react';

import Actions from './controls/actions';
import Icon from './controls/icon';
import React from 'react';
import Title from './controls/title';
import { action } from 'mobx';

@inject('clinicalStore', 'vm')
@observer
class HeaderControl extends React.Component {
  static defaultProps = {
    onEdit: () => {}
  };

  render() {
    return (
      <div className="clinical-page-header">
        <div className="nowrap flex-row" onClick={this.onOpen.bind(this)}>
          <div className="expand flex-none">
            <Icon />
          </div>
          <Title />
          <Actions onEdit={this.props.onEdit} />
        </div>
      </div>
    );
  }

  @action
  onOpen() {
    let { vm, navKey, clinicalStore } = this.props;
    if (clinicalStore.activePageKeys.indexOf(navKey) > -1) {
      vm.open = false;
      clinicalStore.setActivePageKey(navKey, true);
    } else {
      vm.open = !vm.open;
    }
  }
}

export default HeaderControl;
